import type { RouteRecordRaw } from "vue-router";
import Layout from "@/views/layouts/index.vue";

const orderRouter: RouteRecordRaw[] = [
    {
        path: "/orderCenter",
        name: "OrderCenter",
        meta: { title: "交易中心" },
        component: Layout,
        redirect: "/orderCenter/myOrder",
        children: [
            {
                path: "myOrder",
                name: "MyOrder",
                meta: { title: "我的订单" },
                component: () => import("@/views/pages/order/myOrder/index.vue")
            },
            {
                path: "myOrder/detail/:id",
                name: "OrderDetail",
                meta: { title: "订单详情", hidden: true },
                component: () => import("@/views/pages/order/myOrder/detail.vue")
            },
            {
                path: "myOrder/orderConfirm/:id",
                name: "OrderConfirm",
                meta: { title: "订单确认", hidden: true },
                component: () => import("@/views/pages/order/myOrder/orderConfirm.vue")
            },
            {
                path: "myOrder/deliveryDetail/:id",
                name: "deliveryDetail",
                meta: { title: "提货详情", hidden: true },
                component: () => import("@/views/pages/order/myOrder/delivery/detail.vue")
            },
            {
                path: "myInvoice",
                name: "MyInvoice",
                meta: { title: "我的发票" },
                component: () => import("@/views/pages/order/myInvoice/index.vue")
            },
            {
                path: "myInvoice/detail/:id",
                name: "InvoiceDetail",
                meta: { title: "发票详情" },
                component: () => import("@/views/pages/order/myInvoice/detail.vue")
            }
        ]
    }
];

export default orderRouter;
